var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome03Duotone = function SvgHome03Duotone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9FAFC3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18 42V27.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C19.52 24 20.08 24 21.2 24h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C30 25.52 30 26.08 30 27.2V42M4 19 22.08 5.44c.689-.516 1.033-.775 1.41-.874a2 2 0 0 1 1.02 0c.377.1.721.358 1.41.874L44 19M8 16v19.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C11.04 42 12.16 42 14.4 42h19.2c2.24 0 3.36 0 4.216-.436a4 4 0 0 0 1.748-1.748C40 38.96 40 37.84 40 35.6V16L27.84 6.88c-1.377-1.033-2.065-1.55-2.822-1.748a4 4 0 0 0-2.036 0c-.756.199-1.445.715-2.822 1.748z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F8FF",
    d: "M18 42V27.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C19.52 24 20.08 24 21.2 24h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C30 25.52 30 26.08 30 27.2V42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#516B89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18 42V27.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C19.52 24 20.08 24 21.2 24h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C30 25.52 30 26.08 30 27.2V42z"
  })));
};
export default SvgHome03Duotone;